import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum IdentityUserTrait {
	User = 'user',
	Admin = 'admin',
	Staff = 'staff',
	LegalGuardian = 'legalGuardian',
}

export interface IdentityProvider extends Record, Dateable {
	organizationId: number;
	displayName: string;
	ssoEnabled: boolean;
	syncEnabled: boolean;
	connectionActive: boolean;
	connectionType: string;
	directoryActive: boolean;
	directoryType: string;
	requiredForIdentityUserTraits: IdentityUserTrait[];
	unusedIdentityUserTraits: IdentityUserTrait[];
}

export interface ScrubbedIdentityProvider extends Record {
	displayName: string;
	requiredForIdentityUserTraits: IdentityUserTrait[];
}

export interface AttributeMapping {
	id: number;
	userFieldId: number;
	identityProviderId: number;
	key: string;
}
